import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import { AuthProvider } from './auth/AuthContext'
import { RequireAuth } from './auth/RequireAuth'
import AdminLayout from './components/AdminLayout'
import AppShell from './components/AppShell'
import AdminAudit from './pages/AdminAudit'
import AdminSources from './pages/AdminSources'
import AdminTenant from './pages/AdminTenant'
import AdminUsers from './pages/AdminUsers'
import Analytics from './pages/Analytics'
import AssetHealth from './pages/AssetHealth'
import ControlTower from './pages/ControlTower'
import Cost from './pages/Cost'
import EngineerPWA from './pages/EngineerPWA'
import EnterpriseDashboard from './pages/EnterpriseDashboard'
import ForgotPassword from './pages/ForgotPassword'
import Login from './pages/Login'
import MapView from './pages/MapView'
import NotificationPrefs from './pages/NotificationPrefs'
import PlatformSessions from './pages/PlatformSessions'
import PlatformTenants from './pages/PlatformTenants'
import Readiness from './pages/Readiness'
import RequirePlatformAdmin from './auth/RequirePlatformAdmin'
import ResetPassword from './pages/ResetPassword'

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Auth-adjacent surfaces — no shell */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Engineer PWA is mobile-first and deliberately unshelled — it's
              the field-side surface, not the dispatcher's dashboard. */}
          <Route
            path="/engineer"
            element={
              <RequireAuth>
                <EngineerPWA />
              </RequireAuth>
            }
          />

          {/* Everything else lives inside the sidebar-shell layout. */}
          <Route
            element={
              <RequireAuth>
                <AppShell />
              </RequireAuth>
            }
          >
            <Route path="/" element={<ControlTower />} />
            <Route path="/enterprise" element={<EnterpriseDashboard />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/map" element={<MapView />} />
            <Route path="/readiness" element={<Readiness />} />
            <Route path="/asset-health" element={<AssetHealth />} />
            <Route path="/cost" element={<Cost />} />
            <Route path="/notifications-prefs" element={<NotificationPrefs />} />

            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Navigate to="users" replace />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="tenant" element={<AdminTenant />} />
              <Route path="sources" element={<AdminSources />} />
              <Route path="audit" element={<AdminAudit />} />
            </Route>

            {/* Platform Admin surface — visible only to users holding a
                platform_admin membership. Non-platform users get bounced
                back to Control Tower by RequirePlatformAdmin. */}
            <Route
              path="/platform"
              element={<RequirePlatformAdmin><Navigate to="tenants" replace /></RequirePlatformAdmin>}
            />
            <Route
              path="/platform/tenants"
              element={<RequirePlatformAdmin><PlatformTenants /></RequirePlatformAdmin>}
            />
            <Route
              path="/platform/sessions"
              element={<RequirePlatformAdmin><PlatformSessions /></RequirePlatformAdmin>}
            />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
